import React from 'react';

import {Link} from 'react-router';
import styled from 'styled-components';

import {getObjectName} from 'app/utils/fallbacks';
import {markAsSafe} from 'app/utils/strings';

import {SearchSerializedType} from 'sweet-types';

interface Props {
  searchItem: SearchSerializedType;
}
export const SearchListItem = ({searchItem}: Props) => (
  <div className="row border-bottom py-2 d-flex align-items-center">
    <div className="col-12">
      <Link
        className="text-dark font-weight-bold d-block d-sm-inline"
        to={searchItem.html_url}
      >
        {getObjectName(searchItem, 'procedure')}
      </Link>
    </div>
    <div className="col-12">
      {searchItem.highlight != null ? (
        <StyledHighlightDiv
          dangerouslySetInnerHTML={markAsSafe(searchItem.highlight)}
        />
      ) : null}
    </div>
  </div>
);

const StyledHighlightDiv = styled.div.attrs({
  className: 'small text-truncate font-italic text-secondary',
})`
  b {
    font-weight: normal;
    background-color: rgba(255, 255, 0, 0.5);
  }
`;
